// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M21 22H3V20H21V22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13.1553 10.2227H10.8447L12 7.71973L13.1553 10.2227Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23 18H1V2H23V18ZM11.0527 5L6.67285 14.4893L8.48926 15.3271L9.92188 12.2227H14.0781L15.5107 15.3271L17.3271 14.4893L12.9473 5H11.0527Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-automation-filled')
export default class AutomationFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'automation-filled',
    }
  }
}
